
  export const NUTRITIONTIPSS_RECEIVED = "NUTRITIONTIPSS_RECEIVED";
  export const SET_NUTRITIONTIPS = "SET_NUTRITIONTIPS";
  export const CREATE_NUTRITIONTIPS = "CREATE_NUTRITIONTIPS";
  export const SET_PROPERTY_NUTRITIONTIPS = "SET_PROPERTY_NUTRITIONTIPS";
  